import axios from 'axios'

export default class Selo {
  constructor(tokenBearer, url, id) {
    this.url = url
    this.tokenBearer = tokenBearer
    this.id = id
  }

  getSelo(args = '') {
    let url = `${this.url}/api/unimed/selos/${this.id}?${args}`
    return new Promise(async (resolve, reject) => {
      let optionsSelo = {
        method: 'get',
        url,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseSelo = await axios(optionsSelo)
        resolve(responseSelo)
      } catch (err) {
        reject(err)
      }
    })
  }

  getSelosAtivos() {
    let url = `${this.url}/api/unimed/selos/${this.id}/ativos`
    return new Promise(async (resolve, reject) => {
      let optionsSelo = {
        method: 'get',
        url,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseSelo = await axios(optionsSelo)
        resolve(responseSelo)
      } catch (err) {
        reject(err)
      }
    })
  }

  delSelos(data) {
    let url = `${this.url}/api/unimed/selos/${this.id}`
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'delete',
        url,
        headers: {
          Authorization: this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  getTiposSelo() {
    let url = `${this.url}/api/unimed/selos/tipoSelo`
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'get',
        url,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  putSelo(data) {
    let url = `${this.url}/api/unimed/selos/${this.id}`
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url,
        headers: {
          Authorization: this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }

  getTipoSeloFormatoAno() {
    let url = `${this.url}/api/unimed/selos/tipoSelosAno`
    return new Promise(async (resolve, reject) => {
      let optionsSelo = {
        method: 'get',
        url,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseSelo = await axios(optionsSelo)
        resolve(responseSelo)
      } catch (err) {
        reject(err)
      }
    })
  }

  getPermissaoExcluirSelo() {
    let url = `${this.url}/api/unimed/selos/selo-papel-excluir`
    return new Promise(async (resolve, reject) => {
      let optionsSelo = {
        method: 'get',
        url,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseSelo = await axios(optionsSelo)
        resolve(responseSelo)
      } catch (err) {
        reject(err)
      }
    })
  }

  putSeloNivel(data) {
    let url = `${this.url}/api/unimed/selos/tipo-selo-nivel`
    return new Promise(async (resolve, reject) => {
      let options = {
        method: 'put',
        url,
        headers: {
          Authorization: this.tokenBearer
        },
        data
      }

      try {
        let response = await axios(options)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}
